import { api } from '../Api/api';

export interface SendEmailRequest {
  email: string;
}

export interface SendEmailResponse {
  success: boolean;
  code?: string;
  message?: string;
}

export interface VerifyEmailCodeRequest {
  email: string;
  code: string;
}

export interface VerifyEmailCodeResponse {
  success: boolean;
  message?: string;
}

// Função para enviar código de verificação por e-mail
export const sendEmailVerificationCode = async (request: SendEmailRequest): Promise<SendEmailResponse> => {
  try {
    const response = await api.post<SendEmailResponse>('/auth/validate-email-and-send-otp', {
      email: request.email
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao enviar código por e-mail:', error);
    throw error;
  }
};